import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import * as actions from "../../store/agencies/actions";
import TableGridView from "../../components/TableGridView";
import Filterform from "./Filterform";
import "./style.scss";
import moment from 'moment';
//import ConfirmDialog from "../../components/ConfirmDialog/ConfirmDialog";
import Tooltip from '@material-ui/core/Tooltip';
import ConfirmDialog from "../../components/ConfirmDialog/ConfirmDialog";
import { ButtonComponent } from "../../components/Controls/Button/Button";
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import SamplingConfirmation from "./SamplingConfirmation";

const Agencies = ({ intl: { messages } }) => {
  const dispatch = useDispatch();
  const [searchValues, setSearchValues] = useState({});
  const { samples } = useSelector((state) => state.agencies);
  const [selectedSample, setSelectedSample] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const [cancelConfirmation, setCancelConfirmation] = useState(false);
 // const user = useSelector((state) => state.auth?.user?.data);

  useEffect(() => {
    dispatch(
      actions?.getAgencySamplesListRequest({
        page: 1,
        sort: "created_at,desc",
      })
    );
 
    return () => {
      dispatch(actions.getAgencySamplesListReceive([]));
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //table n grid view render
  const headings = [
    messages.agencies.patient_name,
    messages.agencies.appointment_date,
    messages.agencies.sample_type,
    messages.agencies.sample_quantity,
    messages.agencies.tube_type,
    messages.agencies.tubes_count,
    messages.agencies.status,
    messages.agencies.action,
  ];

  const renderTableData = () => {
    return samples?.data?.map((sample, i) => {
      const {
        patient_name,
        date,
        sample_type,
        sample_quantity,
        tube_type_name,
        tubes_count,
        status,
        status_name
      } = sample;

      //if (user?.role_id !== 1 && user?.role_id !== 3) return <div className="flex center pt-5">You are not authorized</div>

      return [
        patient_name?.length && <Tooltip title={patient_name} placement="bottom" >
            <span>{patient_name?.length > 20 ? `${patient_name?.substring(0,20)}...` : patient_name}</span>
        </Tooltip>,
        moment(date).format("DD[.]MM[.]YYYY"),
        sample_type,
        sample_quantity,
        tube_type_name,
        tubes_count,
        status > 1 ? status_name : <ButtonComponent
            content={messages.agencies.form.confirm}
            type="button"
            classes={`cyan-button px-8`}
            handleClick={(e) => {
                e.preventDefault();
                setSelectedSample(sample); 
                setShowConfirmModal(true);
            }}
        />,
        status > 1 && <EditRoundedIcon className="edit-icon" 
                          onClick={() => {setSelectedSample(sample); setShowConfirmModal(true)}} />
      ];
    });
  };

  const handlePageChange = (e, page) => {
    return dispatch(
      actions?.getAgencySamplesListRequest({
        page,
        sort: "created_at,desc",
        ...searchValues,
      })
    );
  };
 
  return (
    <>
      {samples ? (
        <div style={{ padding: '5px 0'}}>
          <TableGridView
            title={
              <>
                <FormattedMessage
                  values={{
                    total: samples?.total,
                    totals: samples?.data?.length,
                  }}
                  id="agencies.agency_of"
                  defaultMessage={messages.agencies.agency_of}
                />
              </>
            }
            Form={<Filterform setSearchValues={setSearchValues} />}
            table={{
              stickyHeader: true,
              headings: headings,
              data: renderTableData(),
              headClass: "bg-white table-head",
              noData: messages.noData.no_data,
            }}
            //gridView={renderGridView}
            pagination={{
              count: samples?.last_page,
              page: samples?.current_page,
              handleChange: handlePageChange,
            }}
          />
        </div>
      ) : null}

      <SamplingConfirmation show={showConfirmModal} 
                close={() => {setSelectedSample(null); setShowConfirmModal(false)}}
                sample={selectedSample} 
                cancel={() => {setSelectedSample(null); setShowConfirmModal(false)}}
                />

      <ConfirmDialog 
                  show={cancelConfirmation} 
                  onCancel={() => {
                    setCancelConfirmation(false)
                  }}
                  onConfirm={() => {
                    setShowConfirmModal(false);
                    setCancelConfirmation(false);
                  }}
                  content={messages.warningMsgs.warning_close_window}
                  cancelBtn={messages.warningMsgs.cancel}
                  confirmBtn={messages.warningMsgs.confirm} />
    </>
  );
};

export default injectIntl(Agencies);
